import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  // Format how the date appears in the input (e.g., 15-06-2024)
  format(date: NgbDateStruct | null): string {
    if (!date) return '';
    const day = String(date.day).padStart(2, '0');
    const month = String(date.month).padStart(2, '0');
    const year = date.year;
    return `${day}-${month}-${year}`;
  }

  // Convert typed string back to date object
  parse(value: string): NgbDateStruct | null {
    if (!value) return null;
    const parts = value.trim().split('-');
    if (parts.length !== 3) return null;

    const day = +parts[0];
    const month = +parts[1];
    const year = +parts[2];

    return { day, month, year };
  }
}